/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function () {
    'use strict';

    function removeFormat(number) {
        number = number + '';
        var pos = number.lastIndexOf(',');
        if (pos === -1) {
            pos = number.lastIndexOf('.');
        }
        // comma in string
        if (pos !== -1) {
            var int = parseInt(number.substring(0, pos).replace(/\D/g, ''), 10);
            var floatStr = number.substring(pos + 1).replace(/\D/g, '');
            var floatLength = floatStr.length;
            var float = parseInt(floatStr, 10);
            if (int && float) {
                return int + (float / Math.pow(10, floatLength));
            }
            if (!int && float) {
                return float / Math.pow(10, floatLength);
            }
            if (int) {
                return int;
            }
            return 0;
        }
        return parseFloat(number.replace(/\D/g, ''));
    }
    var formatters = {};
    function getCurrencyFormatter(currency) {
        var local = 'is-IS';
        if (formatters[currency]) {
            return formatters[currency];
        }
        formatters[currency] = new Intl.NumberFormat(local, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'code'
        });
        formatters[currency].formatWithoutSymbol = function (number) {
            var result = formatters[currency].format(number);
            return result.replace(new RegExp(currency, 'i'), '').trim();
        };
        return formatters[currency];
    }
    function formatMoney(amount, currency) {
        var value = getCurrencyFormatter(currency || 'ISK').formatWithoutSymbol(removeFormat(amount));
        return (isNaN(amount) || !isFinite(amount)) ? '-' : value;
    }
    var CurrencyHelper = {
        formatMoney: formatMoney,
        removeFormat: removeFormat
    };

    var $ = jQuery;
    var initCalculate = function () {
        $('input.amount').on('keyup', function (e) {
            calculateAllOthers(e.target);
        });
        var iskInput = document.querySelectorAll('input.isk.amount');
        if (iskInput.length) {
            iskInput.forEach(calculateAllOthers);
        }
    };
    var inputs;
    var calculateAllOthers = function (currentInput) {
        if (!inputs) {
            inputs = [].slice.call(document.querySelectorAll('input.amount'));
        }
        var currentAmount = CurrencyHelper.removeFormat(currentInput.value) * parseFloat(currentInput.dataset.sell);
        inputs
            .filter(function (input) { return input.id !== currentInput.id; })
            .filter(function (input) { return input.dataset.source === currentInput.dataset.source; })
            .forEach(function (input) {
            var division = parseFloat(input.dataset.sell);
            if (division === 0) {
                division = parseFloat(input.dataset.buy);
            }
            input.value = CurrencyHelper.formatMoney(currentAmount / division, input.dataset.currency || 'ISK');
        });
    };
    var initTabs = function () {
        var $tabs = $('.box_currencyconverter > .boxText');
        if (!$tabs.length) {
            $tabs = $('.box_currencyconverter');
        }
        $tabs.tabs();
        $tabs.removeClass('ui-widget ui-widget-content ui-corner-all');
        $('#currencyTabs').removeClass('ui-widget-header ui-corner-all ui-tabs-nav');
        $('#currencyTabs > li').removeClass('ui-state-default ui-corner-top');
    };
    var CurrencyHelper$1 = {
        init: function () {
            initTabs();
            initCalculate();
        }
    };

    window['currencyConverter'] = {};
    window['currencyConverter'].converter = CurrencyHelper$1;
    // tslint:disable-next-line:no-empty
    var module = (function () { });

    return module;

}());
typeof tsBuild === 'function' && tsBuild();})();
